import { IPanicRequestDTO } from 'api/swagger/ApiClient';
import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { PanicRequestsData } from 'model/mobile-app-dashboard';

@customElement('panic-alerts-box')
export class PanicAlertsBoxCustomElement {
  @bindable
  data: PanicRequestsData;
  @bindable
  showPanicRequest: (any) => void = null;

  @computedFrom('data.panicRequests.length')
  get panicRequests() {
    return this.data.panicRequests.map(x => ({
      ...x,
      showPanicRequest: (panicRequest: IPanicRequestDTO) => this.showPanicRequest({ panicRequest: panicRequest })
    } as PanicRequestModel));
  }
}

export interface PanicRequestModel extends IPanicRequestDTO {
  showPanicRequest(panicRequest: IPanicRequestDTO): void;
}
